<template>
    <div class="section-posts2 section-posts-planner-view">
        <div class="navigations">
            <div class="navigation-date">
                <div class="btn-radius" @mouseenter="eventIsDrag && goToToday()" @click="goToToday">{{ $t('dash.posts.nav.today') }}</div>
                <div class="btn-radius icon" @mouseenter="eventIsDrag && prev()" @click="prev"><i class="fa-solid fa-chevron-left"></i></div>
                <div class="btn-radius icon" @mouseenter="eventIsDrag && next()" @click="next"><i class="fa-solid fa-chevron-right"></i></div>
                <div class="date">
                    <input type="date" :lang="$i18n.locale || 'fr-FR'" v-model="models.date" @click="(e)=>e.target.showPicker()" @change="setDateFromDatePiker"/>
                    <h4>{{ dateFormat }}</h4>
                    <i class="fa-solid fa-caret-down"></i>
                </div>
             
            </div>
            <div class="navigation-filter">
                <div class="btn-radius filter" :data-count="filterCount" @click.stop="filterIsOpen = true">
                    {{ $t('dash.posts.list.filter') }}
                    <FilterNavigation v-if="filterIsOpen" @close="filterIsOpen = false" :filter.sync="filter" @updateCalendar="refreshEvents" :pageIds="pagesSelected.map(p => p.id)"/>
                </div>
            
                    <ContextMenu :options="contextMenuOptions" :id="'ContextMenuPlanner'" v-on:clickOption="clickOption">
                        <div class="btn-radius icon">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                    </ContextMenu>
              
                <!-- <div class="btn-radius">Autres options</div> -->
                <div class="btn-radius icon" @click="getPlannerData(0)"><i class="fa-solid fa-rotate-right"></i></div>
            </div>
            <MainNavigation v-on="$listeners" :tabSelected="tabSelected" @switchCurrentViewType="switchCurrentViewType" :currentViewType="currentViewType"/>
        </div>
        <div class="planner" :class="[currentViewType]">
            <div class="loading-overlay" v-if="isLoading"><i class="fa-sharp fa-solid fa-spinner-third"></i>{{ $t('dash.posts.list.loading') }}</div>
            <Calendar
                ref="calendar"
                :initialEvent="Object.values(events)"
                :eventIdSelected="eventIdSelected"
                @eventDragStart="handleDragStart"
                @eventDragStop="handleDragStop" 
                @selectDate="handleDateSelect"
                @eventClick="handleEventClick"
            />
        </div>
        <template v-if="eventIsDrag">
            <div class="prevMonthHover" @mouseenter="prev"></div>
            <div class="nextMonthHover" @mouseenter="next"></div>
        </template>
        <DrawerPost
            v-if="eventIdSelected && events[eventIdSelected]"
            ref="drawerPost"
            :event="events[eventIdSelected]"
            @close="closeDrawer"
            @deletePost="handlerDeletePost"
           
        />
        <SharedPlanner v-if="displaySharedPlanner" :display="displaySharedPlanner" @close="displaySharedPlanner = false"/>
    </div>
 
</template>

<script>
    import Store from '@/store'
    import { EventBus } from '@/event-bus';
    import MainNavigation from './components/MainNavigation.vue'
    import Avatar from '@/components/dash/utils/avatar.vue'
    import FilterNavigation from './components/Filter.vue'
    import DrawerPost from './components/drawer/index.vue'
    import postMixins from '@/components/mixins/Posts.vue'
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import plannerBehavior from './mixins/plannerBehavior.js'
    import sectionPostMixins from './mixins/main.js'
    import postCreatorMixins from '@/components/dash/postCreator/mixins/main.js'
    import SharedPlanner from './components/planner/SharedPlanner.vue'
    import { convertOldDraft, patchDraft, convertDirectPostToNews } from './utils/draft.js'
    import Calendar from './components/planner/calendar/Main.vue'


    export default {
        components: {
            MainNavigation,
            Avatar,
            FilterNavigation,
            DrawerPost,
            ContextMenu,
            SharedPlanner,
            Calendar
        },

        mixins: [plannerBehavior, postMixins, sectionPostMixins, postCreatorMixins],
        props: {
            tabSelected: String,
            defaultDate: String,
            scrollToHour: Boolean,

            defaultSelectedPost: Object,
            autoValidatePostSelected: Boolean,
            autoEditPostSelected: Boolean
        },

        data() {
            return {
                models : {
                    date : new Date().toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')
                },
 
                currentEvents: [],
                currentDate: null,
                currentViewType: localStorage.getItem('planner/currentViewType') || 'dayGridMonth',
                eventIsDrag: false,
                lastEventDraged: null,
                events : {},

                eventsHistory :{
                    'prev': null,
                    'next': null
                },

                isLoading: false,

                timeoutGetPlannerData: null,
                lastTimeGetPlannerData: null,

                eventIdSelected : null,
                filterIsOpen: false,
                filter: {
                    search: '',
                    statusDisplay:  {
                        scheduled: true,
                        posted: true,
                        draft: true,
                        pending: true,
                        failed: true,
                        removed: false,
                        standby: true,
                        awaiting_approval: true,
                        to_validate: true,
                    },
                    typesDisplay:  {
                        carousel: true,
                        document: true,
                        reel: true,
                        video: true,
                        image: true,
                        story: true,
                    },
                    creators: [],
                    labels: [],
                },
                eventsAddAfterLoading: [],
                displaySharedPlanner: false,
                activeSynchronized: false,
                eventdefaultSelectedPost: null
            }
        },

        mounted () {
            if (this.$refs.calendar) {
                const calendarApi = this.$refs.calendar.getApi(); 
              
                if (this.defaultDate) {
                    this.currentDate = new Date(this.defaultDate)
                    const dateFormat = this.currentDate.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')
                    this.models.date = dateFormat
                    calendarApi.gotoDate(dateFormat)
                    
                    if (this.scrollToHour) {
                        this.$nextTick(()=>{
                            const hours = this.currentDate.getHours()
                            calendarApi.scrollToTime(hours)
                        })
                    }
                }else{
                    this.currentDate = calendarApi.getDate()
                }
                // this.currentViewType = calendarApi.view.type
                calendarApi.changeView(this.currentViewType)
                this.getPlannerData(0, !this.defaultDate || !this.scrollToHour)
            }

            if (localStorage.getItem("filterPlanner")) {
                const saved = JSON.parse(localStorage.getItem("filterPlanner"))
                this.filter = {
                    ...this.filter,
                    ...saved,
                    statusDisplay: { ...this.filter.statusDisplay, ...(saved.statusDisplay || {}) },
                    typesDisplay: { ...this.filter.typesDisplay, ...(saved.typesDisplay || {}) },
                    creators: Array.isArray(saved.creators) ? saved.creators : [],
                    labels: Array.isArray(saved.labels) ? saved.labels : []
                }
            }

            EventBus.$on('planner/refresh', this.getPlannerData);
        },

        methods: {
            async getPlannerData(msTimeout = 1000, forceScroll = false) {
                if (this.timeoutGetPlannerData) clearTimeout(this.timeoutGetPlannerData)

                const time = Date.now()
                this.lastTimeGetPlannerData = time
                this.isLoading = true

                this.timeoutGetPlannerData = setTimeout(async () => {
                
                    //si month alors prendre 3 mois (3 request)
                    //si week alors prendre 3 semaine (3 request)
                    //ajouter un timeout pour si il appui plein de fois sur suivant attendre 1s

                    const calendarApi = this.$refs.calendar.getApi(); // Accès à l'instance de FullCalendar
                    const view = calendarApi.view;

                    const currentStart = calendarApi.getCurrentStart()
                    const currentEnd = calendarApi.getCurrentEnd()

                    console.log('getPlannerData', currentStart, currentEnd)
                    
                    const {body} = await this.postsByPagesV2(
                        this.pagesSelected.map(p=>p.id).join(','),
                        {
                            startDate: currentStart.toISOString(),
                            endDate: currentEnd.toISOString(),
                            planner: true,
                            limit: 1000
                        }
                    )

                    if (this.lastTimeGetPlannerData == time && body.success) {
                     
                        this.events = {}

                        console.log("clem43 posts", body.posts)
                        
                        //trie pour que mes story soient traité en fin de proccess
                        body.posts = body.posts.sort((a, b) => {
                           const aHasStory = a.page && a.page[0] && (a.page[0].story || a.page[0].story_multiple);
                            const bHasStory = b.page && b.page[0] && (b.page[0].story || b.page[0].story_multiple);   
                            return (aHasStory ? 1 : 0) - (bHasStory ? 1 : 0);
                        });
                        
                        if (this.eventdefaultSelectedPost) {
                            this.events[this.eventdefaultSelectedPost.id] = this.eventdefaultSelectedPost
                        }

                        for (const post of body.posts) {
                        
                            const event = await this.buildEvent(post);

                            if (event) {
                                //corection erreur backend
                                if (new Date(event.date) < currentStart || new Date(event.date) > currentEnd) continue;
                                if (!event.originalPost.page || !event.originalPost.page.length) continue;
                                
                                
                                if (!this.$store.getters['planner/staticEvents'][event.id]) {

                                    // if (event.originalPost.type == 'newsFeed') {
                                    //     this.events[event.id] = event;
                                    //     continue
                                    // }
                                
                                    let storification = null
                                    let storificationDate = null

                                    //storification planifier ?
                                    if (event.originalPost.page[0].storification && event.originalPost.page[0].story) {
                                        storification = true

                                        //si storification et que le post est deja poster alors detecter si la storification est en cours de posting 
                                        if (
                                            event.originalStatus == 'scheduled' && 
                                            this.events[event.id] && 
                                            this.events[event.id].originalStatus == 'posted' && 
                                            new Date(event.date).getTime() - new Date(this.events[event.id].date).getTime() <= 300000 // si storification prevu dans les 5min (300000ms) alors pennding
                                        ) {
                                            event.status = 'pending'
                                        }
                                    }
                                    
                                    if (!storification) {
                                        if (this.$store.getters['planner/patchEvents'][event.id]) {
                                            this.events[event.id] =  {...event, ...this.$store.getters['planner/patchEvents'][event.id]};
                                        }else {
                                            this.events[event.id] = event;
                                        }
                                        
                                    } 


                                    // Storification "virtuelle" reconstruite depuis saveAllFormData :
                                    // uniquement pour les anciens brouillons PG, qui n'ont jamais de
                                    // vrai pageEmbed storification. Pour un brouillon Mongo/ES, ce
                                    // pageEmbed existe désormais réellement et est déjà couvert par le
                                    // check plus haut (event.originalPost.page[0].storification) —
                                    // reconstruire ici en plus produisait le même id ("..._storification")
                                    // et écrasait la vraie entrée dans this.events selon l'ordre de
                                    // traitement, avec un originalPost pointant à tort vers la
                                    // publication de base.
                                    const eventIsPgDraft = !/^[0-9a-f]{24}$/i.test(event.originalPost.id || '')
                                    if (!storification && event.page.network == "instagram" && event.originalStatus == "draft" && eventIsPgDraft) {
                                        if (event.draft.saveAllFormData && event.draft.tab !== 'story') {

                                            try {
                                                storification = event.draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification.active   
                                            } catch (error) {}

                                            try {
                                                storificationDate = event.draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification.planifiedDate
                                            } catch (error) {
                                                
                                            }
                                            
                                            if (storification !== false) {
                                                try {
                                                    storification = event.draft.saveAllFormData.networks["instagram"].formDataNetwork.instagram.storification.active
                                                } catch (error) {}
                                            }

                                                if (!storificationDate) {
                                                try {
                                                    storificationDate = event.draft.saveAllFormData.networks["instagram"].formDataNetwork.instagram.storification.planifiedDate
                                                } catch (error) {}
                                            }
        
                                            if (storification !== false) {
                                                try {
                                                    storification = event.draft.saveAllFormData.main.formDataNetwork.instagram.storification.active
                                                } catch (error) {}
                                            }

                                            if (!storificationDate) {
                                                try {
                                                    storificationDate = event.draft.saveAllFormData.main.formDataNetwork.instagram.storification.planifiedDate
                                                } catch (error) {}
                                            }

                                            
                                        }
                                    }

                                    if (storification) {
                                        console.log('trouvé storification', event)
                                        const eventStorification = {...event}
                                        eventStorification.id = eventStorification.id + "_storification"
                                        eventStorification.type = 'story'
                                        eventStorification.content = 'Storification'

                                        if (storificationDate && storificationDate.timestamp) {
                                            console.log('trouvé storification date', storificationDate)
                                            eventStorification.date = new Date(storificationDate.timestamp).toISOString()
                                        }  

                                        if (event.originalStatus == "draft") {
                                            ///recherche de enclosure
                                            let fileId;

                                            const fileIdSearch = function(files) { 
                                                try {
                                                    console.log('fileIdSearch')
                                                    return files.find((file) => (
                                                        ['video','image'].includes(eventStorification.draft.files[file.id].info.type2) && eventStorification.draft.files[file.id].info.type !== 'image/gif'
                                                    )).id
                                            
                                                } catch (error) {
                                                    return null
                                                }
                                            }
                                    
                            
                                    
                                            if (eventStorification.draft.saveAllFormData && eventStorification.draft.saveAllFormData.pages && eventStorification.draft.saveAllFormData.pages[eventStorification.page.id] && eventStorification.draft.saveAllFormData.pages[eventStorification.page.id].files) {
                                                fileId = fileIdSearch(event.draft.saveAllFormData.pages[eventStorification.page.id].files)
                                            }else if (eventStorification.draft.saveAllFormData && eventStorification.draft.saveAllFormData.networks && eventStorification.draft.saveAllFormData.networks['instagram'] && eventStorification.draft.saveAllFormData.networks['instagram'].files) {
                                                fileId = fileIdSearch(eventStorification.draft.saveAllFormData.networks['instagram'].files)
                                            }else if(eventStorification.draft.saveAllFormData){
                                                fileId = fileIdSearch(eventStorification.draft.saveAllFormData.main.files)
                                            }

                                            if (fileId && eventStorification.draft.files[fileId]) {
                                                if (eventStorification.draft.files[fileId].info.type2 == 'video') {
                                                    eventStorification.image = eventStorification.draft.files[fileId].info.enclosure
                                                }else{
                                                    eventStorification.image = eventStorification.draft.files[fileId].url
                                                }
                                            }
                                        }
                                        
                                        this.events[eventStorification.id] = eventStorification;   
                                    }

                                    //storifcation facebook into draft ?
                                    if (storification && event.page.network == "instagram" && event.originalStatus == "draft") {
                                        let storificationFacebook = null
                                        try {
                                            storificationFacebook = event.draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification.shareInFacebook
                                        } catch (error) {}
                                        
                                        if (storificationFacebook !== false) {
                                            try {
                                                storificationFacebook = event.draft.saveAllFormData.networks["instagram"].formDataNetwork.instagram.storification.shareInFacebook
                                            } catch (error) {}
                                        }

                                        if (storificationFacebook !== false) {
                                            try {
                                                storificationFacebook = event.draft.saveAllFormData.main.formDataNetwork.instagram.storification.shareInFacebook
                                            } catch (error) {}
                                        }
                                        console.log('trouvé storification facebook', storificationFacebook)
                                        if (storificationFacebook) {
                                            const page = this.allPages[event.page.id]
                                            console.log("page",page)
                                            if (page.affected_to) {
                                                const pageFacebook = this.pagesSelected.find(p => p.network_id && p.network_id == page.affected_to)

                                                if (pageFacebook) {
                                                    const eventStorification = {...event}
                                                    eventStorification.page = {
                                                        avatar: page.avatar,
                                                        id: event.page.id,
                                                        network:"facebook",
                                                    }
                                                    eventStorification.id = eventStorification.id + "_facebook_storification"
                                                    eventStorification.type = 'story'
                                                    eventStorification.content = 'Storification'

                                                    if (storificationDate && storificationDate.timestamp) {
                                                        eventStorification.date = new Date(storificationDate.timestamp).toISOString()
                                                    }

                                                    this.events[eventStorification.id] = eventStorification;   
                                                }
                                            }
                                        }
                                    }
                                
                                }
                            }
                        }

                        if (this.eventsAddAfterLoading.length) {
                            for (const event of this.eventsAddAfterLoading) {
                                this.events[event.id] = event;
                            }
                            this.eventsAddAfterLoading = []
                        }

                        this.events = {
                            ...this.events,
                            ...this.$store.getters['planner/staticEvents']
                        }

                        console.log('clem43 load curent',this.events)
                        this.refreshEvents()
                        if (forceScroll) calendarApi.scrollToFirstEvent()
                        this.isLoading = false

                        if(this.activeSynchronized) this.synchronizePosts()

                        ///////////////////// preload data ////////////////////////

                        let date;
            
                        if (!this.eventsHistory.next) {
                            date = new Date(currentEnd)
                            if (view == "dayGridMonth") date.setMonth(date.getMonth()+1) 
                            else date.setDate(date.getDate() + 7);

                            const {body:bodyNext} = await this.postsByPagesV2(this.pagesSelected.map(p=>p.id).join(','), { startDate: currentEnd, endDate: date.toISOString(), planner: true, limit: 1000 })

                            if (this.lastTimeGetPlannerData !== time) return

                            if (bodyNext.success) {
                                this.eventsHistory.next = {}
                                bodyNext.posts.forEach(async (post) => {
                                    let event = await this.buildEvent(post)
                                    if (event) this.eventsHistory.next[event.id] = event
                                });
                            }
                            console.log('clem43 load next',this.eventsHistory.next)
                        }

                        if (!this.eventsHistory.prev) {
                            console.log('clem43 load prev')
                            date = currentStart

                            if (view == "dayGridMonth") date.setMonth(date.getMonth()-1)
                            else date.setDate(date.getDate() - 7);

                            const {body:bodyPrev} = await this.postsByPagesV2(this.pagesSelected.map(p=>p.id).join(','), { startDate: date.toISOString(), endDate: currentStart, planner: true, limit: 1000 })
                            if (this.lastTimeGetPlannerData !== time) return
                                
                            if (bodyPrev.success) {
                   
                                this.eventsHistory.prev = {}
                                bodyPrev.posts.forEach(async (post) => {
                                    let event = await this.buildEvent(post)
                                    console.log('clem43 load prev body', event)
                                    if (event) this.eventsHistory.prev[event.id] = event
                                });
                            }
                            console.log('clem43 load prev',this.eventsHistory.prev)
                        }

                        console.log("getPlannerData event",Object.values(this.events).length)

                        // Check pending approval status for Facebook group posts
                        const pendingEvents = Object.values(this.events).filter(e => e.originalPost && e.originalPost.page && e.originalPost.page[0] && e.originalPost.page[0].pending_approval)
                        if (pendingEvents.length) {
                            Promise.all(pendingEvents.map(event =>
                                this.checkFacebookStatus(event.originalPost._id || event.originalPost.id, event.originalPost.page[0].id)
                                    .then(res => {
                                        if (res && res.body && res.body.status && res.body.status !== 'pending') {
                                            this.$set(this.events[event.id], 'status', res.body.status)
                                        }
                                    })
                                    .catch(() => {})
                            )).then(() => {
                                this.refreshEvents()
                            })
                        }
                    }

                }, msTimeout);
            },

            async synchronizePosts() {
                this.activeSynchronized = true
                
                const calendarApi = this.$refs.calendar.getApi(); // Accès à l'instance de FullCalendar
                const currentStart = calendarApi.getCurrentStart()
                const currentEnd = calendarApi.getCurrentEnd()
                
                if(Date.now() < currentStart.getTime()) return
                
                console.log('synchronizePosts', currentStart, currentEnd)
                
                let synchronizedPosts = localStorage.synchronizedPosts ? JSON.parse(localStorage.synchronizedPosts) : null

                for(let page of this.pagesSelected.filter(p => ['facebook', 'instagram', 'linkedin'].includes(p.network))) {
                    let posts = null

                    if(synchronizedPosts) {
                        let synchronizedPostsPage = synchronizedPosts.find(p => p.page == page.id)
                        if(synchronizedPostsPage 
                                && currentStart.getTime()/1000 >= synchronizedPostsPage.since
                                && currentEnd.getTime()/1000 <= synchronizedPostsPage.until) {
                            posts = synchronizedPostsPage.posts.filter(p => currentStart.getTime()/1000 <= new Date(p.page[0].posted_date).getTime()/1000
                                                                                && currentEnd.getTime()/1000 >= new Date(p.page[0].posted_date).getTime()/1000)
                        }
                    }

                    if(!posts) { 
                        let response = await this.getPostsFromRS(page.id, currentStart.getTime()/1000, currentEnd.getTime()/1000)
                        // console.log('synchronizePosts', page, response)

                        posts = (response && response.body && response.body.posts && response.body.posts.data ? response.body.posts.data : []).filter(p => !Object.values(this.events).find(t => t.originalPost.page?.length && t.originalPost.page.find(pEmbed => pEmbed.post_number
                                    && (pEmbed.post_number.includes(p.id) 
                                        || p.id.includes(pEmbed.post_number) 
                                        || (page.network == 'facebook' && [p.attachments.data[0].target.id, p.id] == pEmbed.post_number)))))
                        
                        console.log('synchronisePosts posts', posts)
                        if(posts.length) {
                            for (const pIndex in posts) {
                                posts[pIndex] = await convertDirectPostToNews(page, posts[pIndex])
                                this.events[`${posts[pIndex].id}${page.id}`] = await this.buildEvent(posts[pIndex], true)
                                this.refreshEvents()
                            }
                            
                        }

                        if(!localStorage.synchronizedPosts) {
                            synchronizedPosts = []
                        }
                        if(!synchronizedPosts.find(s => s.page == page.id)) {
                            synchronizedPosts.push({
                                page: page.id,
                                since: currentStart.getTime()/1000,
                                until: currentEnd.getTime()/1000,
                                posts
                            })
                        }
                        else {
                            let ind = synchronizedPosts.findIndex(s => s.page == page.id)
                            synchronizedPosts[ind] = {
                                page: page.id,
                                since: currentStart.getTime()/1000 < synchronizedPosts[ind].since ? currentStart.getTime()/1000 : synchronizedPosts[ind].since,
                                until: currentEnd.getTime()/1000 > synchronizedPosts[ind].until ? currentEnd.getTime()/1000 : synchronizedPosts[ind].until,
                                posts: synchronizedPosts[ind].posts.concat(posts)
                            }
                        }

                        localStorage.synchronizedPosts = JSON.stringify(synchronizedPosts)
                    }
                    else {
                        console.log('synchronisePosts posts localstorage', posts)
                        for (const pIndex in posts) {
                            this.events[`${posts[pIndex].id}${page.id}`] = await this.buildEvent(posts[pIndex], true)
                            this.refreshEvents()
                        }
                    }
                }
            },

            async changeDatePost(eventId, date, all= null, allStorification	= false) {
            
                const event = this.events[eventId] || (this.lastEventDraged.id == eventId && this.lastEventDraged)
                
                console.log('changeDatePost event', event, date, eventId)

                const isPostsMultipaged = this.isPostsMultipaged(event.originalPost)             
                if (all == null) {
                    if (isPostsMultipaged) {
                        EventBus.$emit("showModal",
                            this.$t('dash.post-creator.modal.warning-title'),
                            this.$t('dash.posts.multi-pages.change_date.body'),
                            this.$t('dash.posts.multi-pages.change_date.btn-all'),
                            this.$t('dash.posts.multi-pages.change_date.btn-one'),
                            ()=>{
                                this.changeDatePost(eventId, date, true)
                            },
                            ()=>{
                                this.changeDatePost(eventId, date, false)
                            },
                        );
                        return
                    }else{
                        all = false
                    }
                }

                if (!this.events[eventId]) {
                    this.events[eventId] = this.lastEventDraged
                    this.refreshEvents()
                }

                
                if (!all) {
                    let dateStorifcation = null
                    let datePostWithStorification = null

                    if (eventId.endsWith('_storification')) {
                        datePostWithStorification = new Date(this.events[eventId.replace('_facebook_storification', '').replace('_storification', '')].date)
                        dateStorifcation = date
                    }else if (this.events[eventId + '_storification']){
                        datePostWithStorification = date
                        dateStorifcation = new Date(this.events[eventId + '_storification'].date)
                    }

                    if (datePostWithStorification && dateStorifcation) {
                        if (datePostWithStorification > dateStorifcation) {
                            allStorification = true
                        }
                    }
                }

                const calendarApi = this.$refs.calendar.getApi();

                let events = [event]

                const _isPgDraft = event.originalPost?.page?.[0]?.isPgDraft

                if (isPostsMultipaged && all == true) {
                    allStorification = true
                    if (event.originalStatus == "draft" && _isPgDraft) {
                        const _draftPages = event.originalPost.draft?.data?.pages || []
                        events = _draftPages.reduce((acc, pageId) => {
                            if (this.events[event.originalPost.id + pageId]) acc.push(this.events[event.originalPost.id + pageId])
                            if (this.events[event.originalPost.id + pageId + '_storification']) acc.push(this.events[event.originalPost.id + pageId + '_storification'])
                            if (this.events[event.originalPost.id + pageId + '_facebook_storification']) acc.push(this.events[event.originalPost.id + pageId + '_facebook_storification'])
                            return acc
                        }, [])
                    }else{
                        events = event.originalPost.page[0].posts_multipages.reduce((acc, {_id, page:pageId}) => {
                            if (this.events[_id + pageId]) acc.push(this.events[_id + pageId])
                            if (this.events[_id + pageId + '_storification']) acc.push(this.events[_id + pageId + '_storification'])
                            if (this.events[_id + pageId + '_facebook_storification']) acc.push(this.events[_id + pageId + '_facebook_storification'])
                            return acc
                        }, [])
                    }
                }else if (eventId.endsWith('_storification') && all) {
                    events = []
                    const originalEventId = eventId.replace('_facebook_storification', '').replace('_storification', '')
                    if (this.events[originalEventId + '_storification'])  events.push(this.events[originalEventId + '_storification'])
                    if (this.events[originalEventId + '_facebook_storification'])  events.push(this.events[originalEventId + '_facebook_storification'])
                }
                console.log('changeDatePost events', events)
                const dateString = date.toISOString()

                //changement de date des events concernés
                events.forEach((event) => {
                    //update data event
                    event.isLoading = true
                    event.date = dateString
                    //event.originalPost.page[0].scheduled_date = dateString
                    
                    //todo
                    calendarApi.setPropsEvent(event.id, 'date', dateString);
                    calendarApi.setPropsEvent(event.id, 'isLoading', true);
                    this.events[event.id] = event
                });
           
                
             
                if (this.isLoading) {
                    this.eventsAddAfterLoading = events
                }

                const saveDraft = event.originalStatus == 'draft'
                    ? (_isPgDraft ? JSON.stringify(event.originalPost.draft.data) : JSON.stringify(event.draft))
                    : event.originalPost.page[0].draft
                let draft = JSON.parse(saveDraft)
                
                if (!draft.saveAllFormData) {
                    const pages =  event.originalPost.page && event.originalPost.page[0].posts_multipages ? 
                        event.originalPost.page[0].posts_multipages.map(({page}) => page) : 
                        [event.page.id]
                    draft = convertOldDraft(draft, pages)
                }

                //update draft
                if (draft.saveAllFormData) {
                    draft = patchDraft(draft)
                    const hours = date.getHours().toString().padStart(2, '0');
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    const formattedHours = `${hours}:${minutes}`;
                    const formattedDate = date.toISOString().split('T')[0];
                    
                    if (eventId.endsWith('_storification') && !all) {
                        if (!draft.saveAllFormData.pages[event.page.id]) draft.saveAllFormData.pages[event.page.id] = {}
                        if (!draft.saveAllFormData.pages[event.page.id].formDataNetwork) draft.saveAllFormData.pages[event.page.id].formDataNetwork = {}
                        if (!draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram) draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram = {}
                        if (!draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification) draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification = {}
                        
                        draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification.planifiedDate = {
                            date: formattedDate,
                            hours: formattedHours,
                            timestamp: date.getTime()
                        }

                    }else if (isPostsMultipaged && !all) {
                        if (!draft.saveAllFormData.pages[event.page.id]) draft.saveAllFormData.pages[event.page.id] = {}
                        draft.saveAllFormData.pages[event.page.id].planifiedDate = {
                            date: formattedDate,
                            hours: formattedHours,
                            timestamp: date.getTime()
                        }

                        if (allStorification) {
                            draft.saveAllFormData.main.formDataNetwork.instagram.storification.planifiedDate = {
                                date: false,
                                hours: false,
                                timestamp: false
                            }

                            

                            for (const [networkName, formData] of Object.entries(draft.saveAllFormData.networks)) {
                                try {
                                    delete formData.formDataNetwork.instagram.storification.planifiedDate
                                } catch (error) { }
                            }

                            for (const [pageId, formData] of Object.entries(draft.saveAllFormData.pages)) {
                                try {
                                    delete formData.formDataNetwork.instagram.storification.planifiedDate
                                } catch (error) { }
                            }
                        }

                      

                    }else{
                        draft.saveAllFormData.main.planifiedDate = {
                            date: formattedDate,
                            hours: formattedHours,
                            timestamp: date.getTime()
                        }

                        draft.saveAllFormData.main.formDataNetwork.instagram.storification.planifiedDate = {
                            date: false,
                            hours: false,
                            timestamp: false
                        }
                        
                        for (const [networkName, formData] of Object.entries(draft.saveAllFormData.networks)) {
                            if (formData.planifiedDate) {
                                delete formData.planifiedDate
                            }


                            try {
                                delete formData.formDataNetwork.instagram.storification.planifiedDate
                            } catch (error) { }
                        }

                        for (const [pageId, formData] of Object.entries(draft.saveAllFormData.pages)) {
                            if (formData.planifiedDate) {
                                delete formData.planifiedDate
                            }

                            try {
                                delete formData.formDataNetwork.instagram.storification.planifiedDate
                            } catch (error) { }
                        }

                    }


                }
                
                if (event.originalStatus == 'draft') {
                    if (_isPgDraft) {
                        event.originalPost.draft.data = draft
                    } else {
                        event.originalPost.page[0].draft = JSON.stringify(draft)
                        event.draft = draft
                    }
                }else{
                    event.originalPost.page[0].draft = JSON.stringify(draft)
                }
              
                try {

                    let scheduledDateInstance  = date
                    
                    const {body} = await this.updatePostScheduledDate(event.originalPost, {
                        date: scheduledDateInstance.toLocaleDateString('sv') + 'T00:00:00.000Z',
                        hour: scheduledDateInstance.getHours(), 
                        minute: scheduledDateInstance.getMinutes(), 
                        scheduledDate: scheduledDateInstance.toISOString(),
                    }, all, allStorification);

                    try {
                        this.newLog(
                            event.originalPost.id, 
                            JSON.stringify(this.generateLog({
                                title: `dash.posts.log.changed-date|${JSON.stringify({ date: scheduledDateInstance.toLocaleString(this.$i18n.locale || 'fr-FR', {dateStyle: 'full', timeStyle: 'short'}) })}`,
                            }))
                            , all
                        )
                    } catch (error) {
                        console.error("Erreur sauvegarde log", error)
                    }
                    

                    if (body.success) {
                        events.forEach(({id:eventId}) => {
                            if (this.events[eventId]) {
                                this.events[eventId].isLoading = false
                                this.events[eventId].draft = draft   
                            }
                            calendarApi.setPropsEvent(eventId, 'isLoading', false);
                        });
                    }else{
                    throw new Error("Error updatePostScheduledDate");
                    }

                    this.getPlannerData(1000)


                } catch (error) {
                    console.error(error)
                    if (event.originalStatus == 'draft') {
                        if (_isPgDraft) {
                            event.originalPost.draft.data = JSON.parse(saveDraft)
                        } else {
                            event.originalPost.page[0].draft = saveDraft
                            event.draft = JSON.parse(saveDraft)
                        }
                    }else{
                        event.originalPost.page[0].draft = saveDraft
                    }

                    this.eventsAddAfterLoading = []

             
                    events.forEach(({id: eventId}) => {
                        if (this.events[eventId]) {
                            this.events[eventId].isLoading = false
                            this.events[eventId].date = dateString
                            this.events[eventId].originalPost.page[0].scheduled_date = dateString
                        }

                        calendarApi.setPropsEvent(eventId, 'isLoading', true);
                        calendarApi.setPropsEvent(eventId, 'dateString', dateString);
                    
                    });
                    
                }

                //this.getPlannerData(1000)
              
            },   

            closeDrawer() {
                this.eventIdSelected = null
                // this.getPlannerData()
            },

            clickOption(contextMenuId, nameOption, event) {

                switch (nameOption) {
                    case 'SharedPlanner':
                        this.displaySharedPlanner = true
                        break;
                    case 'synchronizePosts':
                        this.synchronizePosts()
                        break;
                    default:
                        break;
                }
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
            selectPageIsRetracted() {
                return this.$store.getters['selectPage/selectPageStateListRetracted'];
            },
            dateFormat() {
                if (this.currentDate) {
                    if (this.currentDate instanceof Date) {

                        let options = {}

                        if (this.currentViewType == 'timeGridWeek') {
                            options = {
                                day: 'numeric',
                                month: 'long',
                                year:'numeric'
                            }
                        }else{
                            options = {
                                month: 'long',
                                year:'numeric'
                            }
                        }
                        return this.currentDate.toLocaleDateString(this.$i18n.locale || 'fr-FR', options)
                    }
                }
                return undefined
            },
            contextMenuOptions() {
                return [
                    {label: this.$t('dash.posts.shared-planner.title'), name: 'SharedPlanner'},
                    {label: this.$t('dash.posts.planner.sync'), name: 'synchronizePosts'}
                ]
            },
            filterCount() {
                const creatorActive = this.filter.creators && this.filter.creators.length ? 1 : 0
                const labelActive = this.filter.labels && this.filter.labels.length ? 1 : 0
                return (this.filter.search ? 1 : 0) + (Object.values(this.filter.statusDisplay).includes(false) ? 1 : 0) + (Object.values(this.filter.typesDisplay).includes(false) ? 1 : 0) + creatorActive + labelActive
            },
            currentUser() {
                return this.$store.getters['users/getCurrentUser']
            },
        },

        watch: {
            pagesSelected(newValue, lastValue) {
                console.log('pagesSelected changed', newValue, lastValue)
                this.getPlannerData(1000, !lastValue.length && newValue.length);
            },
            currentDate() {
                this.$set(this.models, 'date', this.currentDate.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-'))
            },
            defaultDate() {
                console.log('defaultDate changed')
                if (this.defaultDate && this.$refs.fullCalendar) {
                    const calendarApi = this.$refs.fullCalendar.getApi();
                    this.currentDate = new Date(this.defaultDate)
                    const dateFormat = this.currentDate.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')
                    this.models.date = dateFormat
                    calendarApi.gotoDate(dateFormat)
                    this.getPlannerData(0, true)
                }
            },


            defaultSelectedPost: {
                immediate: true,
                async handler(newValue, oldValue) {
                    console.log('clem55 defaultSelectedPost', newValue, oldValue)
                    if (this.defaultSelectedPost) {
                        // convert : une publication automatique (bot d'une source) n'a pas de brouillon ; sans conversion le drawer reste vide
                        const event = await this.buildEvent(this.defaultSelectedPost, true);
                        if (!event) return

                        //select page
                        // Page absente du store (supprimée, hors accès) : ne pas insérer undefined dans la sélection
                        if (this.allPages[event.page.id] && !this.pagesSelected.some(p => p && p.id == event.page.id)) {
                            this.pagesSelected.push(this.allPages[event.page.id])
                            this.$store.commit('selectPage/updatePagesSelected', {pagesId :this.pagesSelected.map(p => p.id) } );
                        }
      
                        this.events[event.id] = event;
                        this.eventIdSelected = event.id;
                        this.eventdefaultSelectedPost = event

                        if (this.autoValidatePostSelected) {
                            this.$nextTick(() => {
                                // validatePost only exists on the nested DrawerAssignments child,
                                // mounted just when the drawer's "assignments" tab is active
                                if (this.$refs.drawerPost && typeof this.$refs.drawerPost.validatePost === 'function') {
                                    this.$refs.drawerPost.validatePost()
                                }
                            })
                        }else if (this.autoEditPostSelected && ['scheduled', 'draft'].includes(event.originalStatus)) {
                            this.$nextTick(() => {
                                if (this.$refs.drawerPost) {
                                    this.$refs.drawerPost.editPost()
                                }
                            })
                        }
                       
                    }
                }
            },
            filter: {
                deep: true,
                handler() {
                    localStorage.setItem('filterPlanner', JSON.stringify(this.filter))
                }
            },
            currentUser: {
                immediate: true,
                handler(newValue, oldValue) {
                    if (newValue) this.getPlannerData(0, true)
                }
            }
        },
       

        beforeDestroy() {
            EventBus.$off('planner/refresh', this.getPlannerData);
            // getPlannerData debounces via this.timeoutGetPlannerData; without clearing it here,
            // a pending timer fires after the component (and $refs.calendar) is gone (FRONT-SAAS-J).
            if (this.timeoutGetPlannerData) clearTimeout(this.timeoutGetPlannerData);
        },
    }
  
</script>

<style lang="scss" scoped>

</style>